module.exports = __webpack_public_path__ + "7042ebcb59348ad192a4b2b3cf2f0a7e.pdf";